import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Button } from '@tencent/glue-react-ui';
import { useRefCallback } from '@tencent/glue-react-use';
import { Modal } from '../../../Modal';
import { Tip } from '@tencent/adp-icons-react';
import { usePrefixCls } from '../../../../config/hooks/usePrefixCls';
export var UploadFail = function UploadFail(props) {
  var show = props.show,
    onRetry = props.onRetry,
    _props$msg = props.msg,
    msg = _props$msg === void 0 ? '上传失败' : _props$msg,
    _props$desc = props.desc,
    desc = _props$desc === void 0 ? '上传图片比规定尺寸小，请重新上传' : _props$desc,
    previewUrl = props.previewUrl,
    avatarStyle = props.avatarStyle,
    onClose = props.onClose;
  var retryHandle = useRefCallback(onRetry);
  var cls = usePrefixCls('material-library-upload-fail');
  return React.createElement(Modal, {
    title: "",
    show: show,
    bodyStyle: {
      width: 400
    },
    onCancel: onClose,
    footer: null,
    maskClosable: false
  }, React.createElement("article", {
    className: cls
  }, React.createElement("span", {
    className: "".concat(cls, "-avatar"),
    style: _objectSpread({
      backgroundImage: "url(".concat(previewUrl, ")")
    }, avatarStyle)
  }, React.createElement(Tip, {
    className: "".concat(cls, "-fail-icon"),
    size: 54,
    fill: "#FFA600"
  })), React.createElement("p", {
    className: "".concat(cls, "-msg")
  }, msg), React.createElement("p", {
    className: "".concat(cls, "-desc")
  }, desc), React.createElement(Button, {
    type: "primary",
    onClick: retryHandle
  }, "\u91CD\u65B0\u4E0A\u4F20")));
};